// ============================================================================
//  SHOWS — the single source of truth for the Bhaav Sangam dates.
//
//  Every component, the JSON-LD and scripts/verify-shows.js read from here.
//  Nothing about these shows (city, date, venue, link, time) may be typed into
//  a component directly.
//
//  Optional fields are null when unknown, and null fields are simply not
//  rendered. priceFrom is the lowest ticket price in rupees, shown as
//  "Tickets from ₹499". Never put "TBA" or a placeholder in here — the build fails on it.
//
//  Expiry is automatic (see lib/shows.js): a show drops off sale the day
//  after its date in Asia/Kolkata.
//
//  soldOut: true takes a show off sale for good, whatever its date: no
//  bookingUrl, no Book button anywhere. A sold-out show stays on the home page
//  as a card with a SOLD OUT badge — it is the proof that Antara fills rooms —
//  until it is deleted from this list. Both Bhaav Sangam editions sold out.
// ============================================================================

export const EVENT_TITLE = "Bhaav Sangam";
export const EVENT_TAGLINE = "Where devotion flows together…";
export const EVENT_FORMAT = "Bhajan Jamming";
// Double t. Used as "Catapultt Events presents".
export const PRESENTER = "Catapultt Events";
export const FEATURING = "Anshu Goyal";
export const WITH = ["Antara", "Kashi with Anshu"];

export const POSTER_ALT =
  "Catapultt Events presents Bhaav Sangam, Bhajan Jamming featuring Anshu Goyal with Antara and Kashi with Anshu. Delhi, Friday 23 October, The Grand, New Delhi. Chandigarh, Sunday 25 October, Tagore Theatre, Sector 18.";

export const SHOWS = [
  {
    id: "delhi",
    city: "Delhi",
    date: "2026-10-23",
    venue: "The Grand, Vasant Kunj, New Delhi",
    address: {
      name: "The Grand New Delhi",
      streetAddress: "Nelson Mandela Road, Vasant Kunj Phase 2",
      addressLocality: "New Delhi",
      postalCode: "110070",
      addressCountry: "IN",
    },
    soldOut: true,
    doorsTime: "18:00",
    startTime: "19:30",
  },
  {
    id: "chandigarh",
    city: "Chandigarh",
    date: "2026-10-25",
    venue: "Tagore Theatre, Sector 18, Chandigarh",
    address: {
      name: "Tagore Theatre",
      streetAddress: "Sector 18-B",
      addressLocality: "Chandigarh",
      postalCode: "160018",
      addressCountry: "IN",
    },
    soldOut: true,
    doorsTime: "18:30",
    startTime: "19:00",
  },
];
